export const REFUND_PROCESSING_DAYS = 10;
